export const appealDecisionLocalization = {
  appealPageHeading: {
    en: 'Appeal a decision',
    nb: 'Klage på vedtak',
    nn: 'Klage på vedtak',
  },
  appealPageIntro: {
    en: 'Here you will find information about which decisions you can appeal, when you must appeal, and what information we need from you.',
    nb: 'Her finner du informasjon om hvilke vedtak du kan klage på, når du må klage, og hvilke opplysninger vi trenger fra deg.',
    nn: 'Her finn du informasjon om kva vedtak du kan klage på, når du må klage, og kva opplysningar vi treng frå deg.',
  },
  whenCanYouAppealHeading: {
    en: 'When can you appeal',
    nb: 'Når kan du klage',
    nn: 'Når kan du klage',
  },
  whenCanYouAppealIntro: {
    en: 'You can appeal decisions regarding:',
    nb: 'Du kan klage på:',
    nn: 'Du kan klage på:',
  },
  whenCanYouAppealList1: {
    en: 'Decisions on loans and guarantees',
    nb: 'Vedtak om lån og garantier',
    nn: 'Vedtak om lån og garantiar',
  },
  whenCanYouAppealList2: {
    en: 'Grants for investments and business development in agriculture',
    nb: 'Tilskudd til investeringer og bedriftsutvikling i landbruket',
    nn: 'Tilskot til investeringar og bedriftsutvikling i landbruket',
  },
  whenCanYouAppealList3: {
    en: 'Grants under the development programme for growth and value creation based on agriculture and reindeer husbandry',
    nb: 'Tilskudd under utviklingsprogrammet for landbruks- og reindriftsbasert vekst og verdiskaping',
    nn: 'Tilskot under utviklingsprogrammet for landbruks- og reindriftsbasert vekst og verdiskaping',
  },
  whenCanYouAppealOtherGrants: {
    en: 'Decisions regarding other types of grants cannot be appealed.',
    nb: 'Gjelder vedtaket et annet tilskudd, kan du ikke klage.',
    nn: 'Gjeld vedtaket eit anna tilskot, kan du ikkje klage.',
  },
  appealDeadline: {
    en: 'You have three weeks to submit the appeal from the day you received the decision.',
    nb: 'Du har tre uker på å sende inn klagen fra dagen du mottok vedtaket.',
    nn: 'Du har tre veker på å sende inn klaga frå dagen du mottok vedtaket.',
  },
  appealReadMoreIntro: {
    en: 'Read more about',
    nb: 'Les mer om',
    nn: 'Les meir om',
  },
  appealReadMoreLinkText: {
    en: 'rejections and the right to appeal (in Norwegian)',
    nb: 'Avslag og klagerett',
    nn: 'Avslag og klagerett',
  },
  appealReadMoreOutro: {
    en: 'on our website.',
    nb: 'på våre nettsider.',
    nn: 'på nettsidene våre.',
  },
  whatToIncludeHeading: {
    en: 'What must be included in the appeal',
    nb: 'Hva må du ha med i klagen',
    nn: 'Kva må du ha med i klaga',
  },
  whatToIncludeList1: {
    en: 'The case number stated under "Our reference" at the top of the letter you received',
    nb: 'Saksnummeret som står under "Vår ref" øverst i brevet du mottok',
    nn: 'Saksnummeret som står under "Vår ref" øvst i brevet du mottok',
  },
  whatToIncludeList2: {
    en: 'A description of what is being appealed',
    nb: 'En beskrivelse av hva det klages på',
    nn: 'Ei skildring av kva det vert klaga på',
  },
  whatToIncludeList3: {
    en: 'Other information that may be relevant to the appeal',
    nb: 'Andre opplysninger som kan ha betydning for klagen',
    nn: 'Andre opplysningar som kan ha betydning for klaga',
  },
  whatToIncludeList4: {
    en: 'Relevant documentation, if you have it',
    nb: 'Relevant dokumentasjon, hvis du har det',
    nn: 'Relevant dokumentasjon, dersom du har det',
  },
  whenAnswerHeading: {
    en: 'When will you get an answer',
    nb: 'Når får du svar',
    nn: 'Når får du svar',
  },
  whenAnswerParagraph: {
    en: 'If the appeal meets the requirements, we will respond within three months.',
    nb: 'Hvis klagen oppfyller kravene, svarer vi innen tre måneder.',
    nn: 'Dersom klaga oppfyller krava, svarer vi innan tre månader.',
  },
  submitAppealButton: {
    en: 'Submit appeal',
    nb: 'Send inn klage',
    nn: 'Send inn klage',
  },
} as const;
